import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { PrintNodeInfoService } from 'common/data';

class PrintNodeInfoStore extends BaseStore {
	constructor(rootStore) {
		super(new PrintNodeInfoService(rootStore.app.baasic.apiClient));
	}

	@action async getPrinters({ apiKey }) {
		const response = await this.service.getPrinters(apiKey);
		this.response = { item: response.data.printers };
	}

	@action async findPrintNodeInfo(filter) {
		const response = await this.service.findPrintNodeInfo(filter);
		this.response = response.data;
	}
}

export default PrintNodeInfoStore;



// WEBPACK FOOTER //
// ./src/modules/print-node-info/stores/PrintNodeInfoStore.js